(function () {
  // Adattato alla classe wrapper della card prodotto del tema Arnette.
  const CARD_SELECTOR = '.arn-product-card[data-card-ready]';
  const FALLBACK_MS = 15000;

  const watched = new WeakSet();

  const resolvePrimaryImage = (card) =>
    card.querySelector(
      '.arn-img-wrapper img.variant-image, .arn-img-wrapper img, img.variant-image, img'
    );

  const markReady = (card) => {
    if (!card || !card.isConnected) return;
    if (card.dataset.cardReady === 'true') return;
    card.dataset.cardReady = 'true';
  };

  const watchCard = (card) => {
    let mutationObs = null;
    let fallback = null;

    const cleanup = () => {
      if (mutationObs) { mutationObs.disconnect(); mutationObs = null; }
      if (fallback)   { clearTimeout(fallback);   fallback = null; }
    };

    const observeImage = (img) => {
      if (!img) return false;
      if (img.complete && img.naturalWidth > 0) {
        markReady(card);
        return true;
      }
      const onReady = () => { markReady(card); cleanup(); };
      img.addEventListener('load',  onReady, { once: true });
      img.addEventListener('error', onReady, { once: true });
      return true;
    };

    if (observeImage(resolvePrimaryImage(card))) {
      cleanup();
      return;
    }

    // L'immagine potrebbe essere iniettata dopo (es. slider lazy): osserva il DOM della card.
    mutationObs = new MutationObserver(() => {
      if (card.dataset.cardReady === 'true') { cleanup(); return; }
      if (observeImage(resolvePrimaryImage(card))) cleanup();
    });
    mutationObs.observe(card, { childList: true, subtree: true });

    // Fallback di sicurezza: non lasciare mai lo skeleton acceso all'infinito.
    fallback = window.setTimeout(() => { markReady(card); cleanup(); }, FALLBACK_MS);
  };

  const observeCard = (card) => {
    if (!card || watched.has(card)) return;
    if (card.dataset.cardReady !== 'false') return;
    watched.add(card);
    watchCard(card);
  };

  const hydrate = (root) => {
    if (!root) return;
    if (root.matches?.(CARD_SELECTOR)) observeCard(root);
    root.querySelectorAll?.(CARD_SELECTOR).forEach(observeCard);
  };

  const start = () => {
    hydrate(document);
    const rootObs = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((n) => {
          if (n.nodeType === Node.ELEMENT_NODE) hydrate(n);
        });
      });
    });
    if (document.body) rootObs.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
